import type { ImageLoader } from 'next/image';

export const imageLoader: ImageLoader = ({ src, width, quality = 80 }) =>
  `${src}?w=${width}&q=${quality}`;
